import axios from 'axios';

// Configure axios to use the correct base URL based on PUBLIC_URL
// In development, PUBLIC_URL is empty and proxy handles API calls
// In production, PUBLIC_URL is typically empty (app served at root)
const api = axios.create({
  baseURL: process.env.PUBLIC_URL || ''
});

// Add cache-busting timestamp to all requests (LiteSpeed cache workaround)
api.interceptors.request.use((config) => {
  config.params = config.params || {};
  config.params._t = Date.now();
  return config;
});

export default api;
